module.exports = __webpack_public_path__ + "img/logo.f136739a.png";